export const encryption = (data: string) => {
  return btoa(encodeURIComponent(new window.TextEncoder().encode(data)));
};

export const decryption = (token: string) => {
  const decoder = decodeURIComponent(atob(token)).split(',') as [];
  const buffer = new Uint8Array(decoder);
  const data = new window.TextDecoder().decode(buffer);
  return data;
};

export function encodeTagUrlPath(str: string) {
  return str.replaceAll(',', 'a').replaceAll(':', 'n');
}
export function decodeTagUrlPath(str: string) {
  return str.replaceAll('a', ',').replaceAll('n', ':');
}
